<div class="app-body">
    <main class="main d-flex align-items-center">
        <div class="container" (keyup.enter)="login(form.value)">
            <div class="row">
                <div class="col-md-8 offset-md-2 mx-auto">
                    <form [formGroup]="form">
                        <div class="card-group">
                            <div class="card p-4">
                                <div class="card-body">
                                    <div class="logo"></div>
                                    <div class="input-group mb-1" [ngClass]="{'has-danger': formHelper.hasErrorTooltip(form, username,'username')}" tooltip="ユーザー名は3文字以上にして下さい" triggers="" #username="bs-tooltip" placement="right">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text"><i class="icon-user"></i></span>
                                        </div>
                                        <input type="text" class="form-control" formControlName="username" [ngClass]="{'form-control-danger':formHelper.hasError(form, 'username')}" placeholder="ユーザー名">
                                    </div>
                                    <div class="input-group mb-2" [ngClass]="{'has-danger':formHelper.hasErrorTooltip(form,password,'password')}" tooltip="パスワードは6文字以上にして下さい。" triggers="" #password="bs-tooltip" placement="right">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text"><i class="icon-lock"></i></span>
                                        </div>
                                        <input type="password" class="form-control" formControlName="password" [ngClass]="{'form-control-danger':formHelper.hasError(form, 'password')}" placeholder="パスワード">
                                    </div>
                                    <div class="row">
                                        <div class="col-12">
                                            <button type="button" class="btn btn-primary btn-block" [disabled]="!form.valid" (click)="login(form.value)">ログイン</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                    <div class="text-center text-muted mt-2">version {{ version }}</div>
                </div>
            </div>
        </div>
    </main>
</div>
